<template>
  <gw-entity-filter-item :display-text="displayText" :property-name="propertyName"
    representation-field="nome" :search="finderEstado" :minimum-pattern-length="1"
    :find-values="finderEstadoByIDs" :selection-support="A7EstadoListing">
    <div slot="item" slot-scope="{entity}">
      <b>{{$t('Estado.ui.filterItem.nome')}} </b>{{entity.nome}}<br/>
      <b>{{$t('Estado.ui.filterItem.sigla')}} </b>{{entity.sigla}}<br/>
      <b>{{$t('Estado.ui.filterItem.codigoIBGE')}} </b>{{entity.codigoIBGE}}
    </div>
  </gw-entity-filter-item>
</template>

<script>
import { GwEntityFilterItem, GwCustomFilterItemMixin } from 'guaxinim-web'
import EstadoRestResource from './EstadoRestResource'
import A7EstadoListing from './A7EstadoListing'

export default {
  name: 'a7-estado-filter-item',
  mixins: [GwCustomFilterItemMixin],
  components: {
    GwEntityFilterItem
  },
  data() {
    return {
      A7EstadoListing: A7EstadoListing
    }
  },
  methods: {
    finderEstado(pattern) {
      if (!pattern) return null
      return EstadoRestResource.findEstadoFinderDTO(null, pattern, 10)
    },
    finderEstadoByIDs(ids) {
      return EstadoRestResource.findEstadoFinderDTO(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>